'use client';

import { useEffect, useState } from 'react';
import { DOUBLE_FESTIVAL_CAMPAIGN, isEnterpriseDistribution, ONE_MINUTE } from '@/app/constants';
import { periodOfValidity } from '@/app/utils';

export const useDoubleFestivalCampaign = () => {
  const [now, setNow] = useState<number | null>(null);
  const enabled = !isEnterpriseDistribution && DOUBLE_FESTIVAL_CAMPAIGN.enabled;

  useEffect(() => {
    if (!enabled) return;
    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      const time = Date.now();
      setNow(time);
      // periodOfValidity includes the end instant; hide immediately after it.
      const boundaries = DOUBLE_FESTIVAL_CAMPAIGN.period
        .map((value, index) => Date.parse(value ?? '') + index)
        .filter((boundary) => boundary > time);
      timer = setTimeout(refresh, Math.min(ONE_MINUTE, ...boundaries.map((boundary) => boundary - time)));
    };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [enabled]);

  return enabled && now !== null && periodOfValidity(DOUBLE_FESTIVAL_CAMPAIGN.period, new Date(now));
};
